import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '../components/App';
// Import TailwindCSS v4
import '~/tailwind/application.css';

const container = document.getElementById('react-app');
if (container) {
  const root = ReactDOM.createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
